import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestCategoryService } from "../services/requestCategory.service";
import { CreateRequestCategoryPayload } from "../types/research.types";

import { toast } from "sonner";

export const useCreateRequestCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateRequestCategoryPayload) =>
      requestCategoryService.createRequestCategory(payload),
    onSuccess: () => {
      // Invalidate request categories query to refetch the updated list
      queryClient.invalidateQueries({ queryKey: ["requestCategories"] });
      toast.success("Category Created", {
        description: "Request category created successfully",
      });
    },
    onError: (error) => {
      console.error("Failed to create request category:", error);
      toast.error("Creation Failed", {
        description: "Failed to create request category. Please try again.",
      });
    },
  });
};
